export const CopyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#0A819F"
      d="M7.434 0h3.875c.375 0 .78.188 1.062.469l2.094 2.094c.281.28.469.687.469 1.062V10.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.48 1.48 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 1.5-1.5Zm-5 4h2.5v2h-2v8h6v-1h2v1.5a1.5 1.5 0 0 1-1.5 1.5h-7a1.48 1.48 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 1.5-1.5Z"
    />
  </svg>
);
